export const LangCodeMap = {
    tw: 'zh-tw',
    cn: 'zh-cn',
    en: 'en-us',
    pt: 'pt-br',
    es: 'es-es'
};
